<div [formGroup]="formGroup" class="pure-g">
  <!-- ================= Row 1 ================= -->
  <!-- Part Number -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      label="Part Number"
      formControlName="partCode"
      [attr.invalid]="isControlInErrorState(formGroup.controls['partCode'])"
      fit="small"
      required>
      @if (formGroup.get('partCode')?.hasError('required')) {
        <span slot="errormessage">Part Number is required</span>
      }
      @if (formGroup.get('partCode')?.hasError('maxlength')) {
        <span slot="errormessage">Part Number cannot exceed 50 characters</span>
      }
    </mc-input>
  </div>

  <!-- Part Group -->
  <div class="pure-u-1 pure-u-md-1-2 p-b-16">
    <mc-select
      ngDefaultControl
      label="Part Group"
      formControlName="partGroupCode"
      [attr.invalid]="isControlInErrorState(formGroup.controls['partGroupCode'])"
      fit="small"
      required>
      @for (group of partGroups; track group.code) {
        <mc-option [value]="group.code"> {{ group.code }} - {{ group.description }} </mc-option>
      }
      @if (formGroup.get('partGroupCode')?.hasError('required')) {
        <span slot="errormessage">Part Group is required</span>
      }
    </mc-select>
  </div>

  <!-- ================= Row 2 ================= -->
  <!-- Part Description -->
  <div class="pure-u-1 p-b-16">
    <mc-textarea
      ngDefaultControl
      label="Part Description"
      formControlName="description"
      textarea
      rows="1"
      maxlength="40"
      [attr.invalid]="isControlInErrorState(formGroup.controls['description'])"
      fit="small"
      required>
      @if (formGroup.get('description')?.hasError('required')) {
        <span slot="errormessage">Part Description is required</span>
      }
      @if (formGroup.get('description')?.hasError('maxlength')) {
        <span slot="errormessage">Maximum 40 characters allowed</span>
      }
    </mc-textarea>
  </div>

  <!-- ================= Row 3 ================= -->
  @if (formGroup.hasError('zeroCostPart')) {
    <div class="pure-u-1 p-b-16">
      <mc-notification
        class="zero-cost-warning"
        appearance="warning"
        fit="small"
        icon="exclamation-triangle"
        body="An active part cannot have a cost of 0. Enter an amount or set the part to inactive.">
      </mc-notification>
    </div>
  }

  <!-- Manufacturer Code -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-select
      ngDefaultControl
      label="Manufacturer Code - Description"
      formControlName="partManufacturerCode"
      [attr.invalid]="isControlInErrorState(formGroup.controls['partManufacturerCode'])"
      fit="small"
      required>
      @for (manufacturer of manufacturerCodes; track manufacturer.code) {
        <mc-option [value]="manufacturer.code"> {{ manufacturer.code }} - {{ manufacturer.description }} </mc-option>
      }
      @if (formGroup.get('partManufacturerCode')?.hasError('required')) {
        <span slot="errormessage">Manufacturer Code is required</span>
      }
    </mc-select>
  </div>

  <!-- Amount -->
  <div class="pure-u-1 pure-u-md-1-2 p-b-16">
    <mc-input
      ngDefaultControl
      label="Amount (USD)"
      formControlName="price"
      type="number"
      prefix="$"
      min="0"
      step="0.01"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['price'])"
      required>
      @if (formGroup.get('price')?.hasError('required')) {
        <span slot="errormessage">Amount is required</span>
      }
    </mc-input>
  </div>

  <!-- ================= Row 4 ================= -->
  <!-- Core Value -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      formControlName="coreValue"
      type="number"
      prefix="$"
      min="0"
      step="0.01"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['coreValue'])">
      <span slot="label">Core Value (USD) <span class="mds-neutral--weak__text-color">(Optional)</span></span>
    </mc-input>
  </div>

  <!-- Quantity -->
  <div class="pure-u-1 pure-u-md-1-2 p-b-16">
    <mc-input
      ngDefaultControl
      label="Quantity"
      formControlName="quantity"
      type="number"
      min="0"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['quantity'])">
    </mc-input>
  </div>
</div>
